import { ReactNode } from 'react';

interface Props {
  step: number;
  totalSteps: number;
  variant?: 'dots' | 'bars';
  headerLabel?: string;
  onClose?: () => void;
  onBack: () => void;
  onNext: () => void;
  nextLabel?: string;
  canProceed?: boolean;
  showBack?: boolean;
  fullWidthCta?: boolean;
  children: ReactNode;
}

const OnboardingShell = ({
  step,
  totalSteps,
  variant = 'dots',
  headerLabel,
  onClose,
  onBack,
  onNext,
  nextLabel = 'Next',
  canProceed = true,
  showBack = true,
  fullWidthCta = false,
  children,
}: Props) => {
  return (
    <div className="min-h-screen bg-cream flex flex-col">
      <div className="max-w-md mx-auto w-full px-5 pt-5 flex-1 flex flex-col">
        {variant === 'dots' ? (
          <>
            <p className="text-center text-deep-800 font-bold text-base mb-3">
              Step {step + 1} of {totalSteps}
            </p>
            <div className="flex justify-center gap-2 mb-4">
              {Array.from({ length: totalSteps }).map((_, i) => (
                <div
                  key={i}
                  className={`h-2 rounded-full transition-all ${
                    i === step ? 'w-6 bg-purple-600' : 'w-2 bg-deep-100'
                  }`}
                />
              ))}
            </div>
          </>
        ) : (
          <>
            <div className="flex items-center justify-between mb-3">
              <p className="text-deep-800 font-bold text-base">{headerLabel ?? 'Edit Profile'}</p>
              <button type="button" onClick={onClose} className="text-deep-800 p-1">
                ✕
              </button>
            </div>
            <div className="flex gap-2 mb-4">
              {Array.from({ length: totalSteps }).map((_, i) => (
                <div
                  key={i}
                  className={`h-1.5 flex-1 rounded-full ${i <= step ? 'bg-purple-600' : 'bg-deep-100'}`}
                />
              ))}
            </div>
          </>
        )}

        <div className="flex-1 pb-36">{children}</div>
      </div>

      <div className="fixed bottom-0 left-0 right-0 bg-cream px-5 py-4 pb-[max(1rem,env(safe-area-inset-bottom))] z-20">
        <div className="max-w-md mx-auto">
          {fullWidthCta ? (
            <button
              type="button"
              onClick={onNext}
              disabled={!canProceed}
              className="w-full bg-purple-600 text-white font-semibold rounded-full py-4 shadow-[0_4px_0_hsl(var(--deep-800))] active:translate-y-0.5 active:shadow-[0_2px_0_hsl(var(--deep-800))] transition-all disabled:opacity-50"
            >
              {nextLabel}
            </button>
          ) : (
            <div className="flex items-center justify-between">
              {showBack ? (
                <button
                  type="button"
                  onClick={onBack}
                  className="text-deep-700 font-medium text-base px-3 py-2"
                >
                  ‹ Back
                </button>
              ) : (
                <span />
              )}
              <button
                type="button"
                onClick={onNext}
                disabled={!canProceed}
                className="bg-purple-600 text-white font-semibold rounded-full px-10 py-3.5 shadow-[0_4px_0_hsl(var(--deep-800))] active:translate-y-0.5 active:shadow-[0_2px_0_hsl(var(--deep-800))] transition-all disabled:opacity-50"
              >
                {nextLabel}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OnboardingShell;
